import { gql } from "@apollo/client";
import * as GQL from "src/types/graphql";
import { useRemoteDataQuery } from "./useRemoteDataQuery";

export const GET_SELECTED_SCHOOLS = gql`
  query GetSelectedSchools($formId: uuid!) {
    form_by_pk(id: $formId) {
      form_template {
        key
        enrollment_period {
          key
        }
      }
      form_school_ranks {
        school {
          id
          name
          reference_id
        }
      }
      previous_offer {
        school {
          id
          name
          reference_id
        }
      }
      previous_waitlist {
        school {
          id
          name
          reference_id
        }
      }
      previous_form {
        form_school_ranks {
          school {
            id
            name
            reference_id
          }
        }
      }
    }
  }
`;

export function useSelectedSchoolsByFormId(formId: uuid) {
  const selectedSchoolsQuery = useRemoteDataQuery<
    GQL.GetSelectedSchools,
    GQL.GetSelectedSchoolsVariables
  >(GET_SELECTED_SCHOOLS, {
    fetchPolicy: "cache-and-network",
    variables: { formId },
  });

  return {
    ...selectedSchoolsQuery,
    remoteData: selectedSchoolsQuery.remoteData.map(fromGQL),
  };
}

type School = {
  id: uuid;
  name: string;
  referenceId: string | null;
};
export function fromGQL(gql: GQL.GetSelectedSchools): School[] {
  if (gql.form_by_pk === null || gql.form_by_pk === undefined) {
    return [];
  }

  if (gql.form_by_pk.form_school_ranks.length > 0) {
    return gql.form_by_pk.form_school_ranks.map((sr) => ({
      id: sr.school.id,
      name: sr.school.name,
      referenceId: sr.school.reference_id,
    }));
  }

  if (gql.form_by_pk.previous_offer?.school !== undefined) {
    const school = gql.form_by_pk.previous_offer.school;
    return [
      {
        id: school.id,
        name: school.name,
        referenceId: school.reference_id,
      },
    ];
  }

  if (gql.form_by_pk.previous_waitlist?.school !== undefined) {
    const school = gql.form_by_pk.previous_waitlist.school;
    return [
      {
        id: school.id,
        name: school.name,
        referenceId: school.reference_id,
      },
    ];
  }

  if (
    gql.form_by_pk.previous_form !== null &&
    gql.form_by_pk.previous_form.form_school_ranks.length > 0
  ) {
    return gql.form_by_pk.previous_form.form_school_ranks.map((sr) => ({
      id: sr.school.id,
      name: sr.school.name,
      referenceId: sr.school.reference_id,
    }));
  }

  return [];
}
